<template>
  <v-content>
    <div class="mt-0">
      <div class="container">
        <v-row class="rmError__404Container d-flex row wrap justify-center">
          <v-col cols="12" class="rmError__desc mt-5 mb-4">
            <div>
              <h3>{{ title }}</h3>
              <p v-html="message"></p>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex row wrap justify-center">
            <img
              :src="require(`@assets/images/${image}.png`)"
              alt="error_img"
              class="img-responsive error-img cat"
              id="error-img"
              @click="disturb()"
            />
          </v-col>
          <div class="rmError__cta mt-5 mb-5">
            <router-link
              :to="`/`"
              class="rm-btn rmError__action user-select-none"
              tag="button"
            >
              <span>Go to Homepage</span>
            </router-link>
          </div>
        </v-row>
      </div>
    </div>
  </v-content>
</template>

<script>
export default {
  name: 'Error',
  data() {
    return {
      title: 'Yikes!',
      count: 0,
    };
  },
  computed: {
    message() {
      switch (this.$route.meta.code) {
        case 401:
          return 'You are not allowed to access this page!';
        case 404:
          return 'Not Found!';
        default:
          return 'There seems to be an Internal Server Error. You may want to <br /> head back to the homepage.';
      }
    },
    image() {
      switch (this.$route.meta.code) {
        case 401:
          return 401;
        case 404:
          return 404;
        default:
          return 500;
      }
    },
  },
  methods: {
    disturb() {
      this.count += 1;
      if (this.count >= 2) {
        this.title = 'Hey, Let me sleep!';
        this.message =
          "Pss... Looks like he's having a good dream. Why don't you<br> go to home page and explore!";
      }
    },
  },
  mounted() {
    function deviceOrientationHandler(eventData) {
      let tiltLR = eventData.gamma; // tilt left - right
      if (tiltLR > 24) {
        tiltLR = 24;
      } else if (tiltLR < -24) {
        tiltLR = -24;
      }
      const logo = document.getElementById('error-img');
      logo.style.transform = `rotate(${tiltLR}deg)`;
    }

    // Check device orientation only mobile
    if ('DeviceOrientationEvent' in window) {
      window.addEventListener(
        'deviceorientation',
        deviceOrientationHandler,
        false
      );
    } else {
      document.getElementById('error-img').innerText = '';
    }

    // 3d perspective rotate image
    const screenWidth = window.screen.width / 2;
    const screenHeight = window.screen.height / 2;
    const $elems = document.getElementsByClassName('cat');
    let validPropertyPrefix = '';
    const otherProperty = 'perspective(1000px)';
    const elemStyle = $elems[0].style;

    if (typeof elemStyle.webkitTransform === 'string') {
      validPropertyPrefix = 'webkitTransform';
    } else if (typeof elemStyle.MozTransform === 'string') {
      validPropertyPrefix = 'MozTransform';
    }

    // mouse move listen function
    document.addEventListener('mousemove', (e) => {
      const centroX = e.clientX - screenWidth;
      const centroY = screenHeight - (e.clientY + 13);
      const degX = centroX * 0.04;
      const degY = centroY * 0.03;
      let $elem = '';

      for (let i = 0; i < $elems.length; i += 1) {
        $elem = $elems[i];
        $elem.style[
          validPropertyPrefix
        ] = `${otherProperty} rotateY(${degX}deg)  rotateX(${degY}deg)`;
      }
    });
    console.log(
      '%c💩! Looks like the 🐱 is trying to eat our server. 😹',
      'font-size: 20px'
    );
    console.log('%c Sending 🦄 for the rescue!', 'font-size: 20px');
  },
};
</script>

<style>
.rmError__404Container {
  position: relative;
}
@media screen and (min-width: 768px) {
  .rmError__404Container {
    background: url(https://www.rentomojo.com/public/images/error/404-bg.png)
      no-repeat;
    background-size: contain;
    background-position: -25px 0;
    padding: 100px;
  }
}
.rmError__404Container .rmError__desc {
  text-align: center;
}
.rmError__404Container .rmError__desc h3 {
  font-size: 30px;
  text-align: center;
  color: #313131;
  font-weight: 600;
}
.rmError__404Container .rmError__desc p {
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  color: #717171;
}
.rmError__404Container .error-img {
  margin: 0 auto;
  width: 550px;
}
.rmError__404Container .rmError__cta {
  text-align: center;
}
.rmError__404Container .rmError__cta .rmError__action {
  color: #fff;
  border-radius: 30px;
  background-image: linear-gradient(90deg, #ff8889 0, #ff6769 50%, #ff8889);
  font-size: 16px;
  padding: 10px 30px;
  text-align: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: relative;
  border: none;
  cursor: pointer;
  background-size: 200% auto;
}
.rmError__404Container .rmError__cta .rmError__action:hover {
  box-shadow: none;
  background-position: 100%;
}
.rmError__404Container .rmError__cta .rmError__action span {
  position: relative;
  font-weight: 300;
}
@media screen and (max-width: 768px) {
  .rmError__404Container .rmError__desc h3 {
    font-size: 20px;
  }
  .rmError__404Container .rmError__desc p {
    font-size: 12px;
  }
}
.rm__customCard .rm__customCard-1 {
  width: 15%;
}
.rm__customCard .rm__customCard-2 {
  width: 70%;
}
.rm__customCard .rm__customCard-3 {
  width: 15%;
}
.rm-profile__credit-score-nvs {
  animation: draw 0.5s ease-in-out;
  background-image: linear-gradient(180deg, #f89c41, #e2492a);
  display: block;
  height: 75px;
  margin: 0 auto;
  text-align: center;
  width: 94px;
  box-shadow: 0 2px 4px 0 hsla(0, 0%, 76%, 0.5);
}
.rm-profile__credit-score-nvs span {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  text-align: center;
  top: 28px;
  vertical-align: top;
}
.rm-profile__credit-score-vs {
  animation: draw 0.5s ease-in-out;
  background-image: linear-gradient(90deg, #76e3b7, #00bdc1);
  display: block;
  height: 75px;
  margin: 0 auto;
  text-align: center;
  width: 94px;
  box-shadow: 0 2px 4px 0 hsla(0, 0%, 76%, 0.5);
}
.rm-profile__credit-score-vs span {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  text-align: center;
  top: 28px;
  vertical-align: top;
}
.rmError__404Container {
  position: relative;
}
@media screen and (min-width: 768px) {
  .rmError__404Container {
    background: url(https://www.rentomojo.com/public/images/error/404-bg.png)
      no-repeat;
    background-size: contain;
    background-position: -25px 0;
    padding: 100px;
  }
}
.rmError__404Container .rmError__desc {
  text-align: center;
}
.rmError__404Container .rmError__desc h3 {
  font-size: 30px;
  text-align: center;
  color: #313131;
  font-weight: 600;
}
.rmError__404Container .rmError__desc p {
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  color: #717171;
}
.rmError__404Container .error-img {
  margin: 0 auto;
  width: 550px;
}
.rmError__404Container .rmError__cta {
  text-align: center;
}
.rmError__404Container .rmError__cta .rmError__action {
  color: #fff;
  border-radius: 30px;
  background-image: linear-gradient(90deg, #ff8889 0, #ff6769 50%, #ff8889);
  font-size: 16px;
  padding: 10px 30px;
  text-align: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: relative;
  border: none;
  cursor: pointer;
  background-size: 200% auto;
}
.rmError__404Container .rmError__cta .rmError__action:hover {
  box-shadow: none;
  background-position: 100%;
}
.rmError__404Container .rmError__cta .rmError__action span {
  position: relative;
  font-weight: 300;
}
@media screen and (max-width: 768px) {
  .rmError__404Container .rmError__desc h3 {
    font-size: 20px;
  }

  .rmError__404Container .rmError__desc p {
    font-size: 12px;
  }
}
</style>
